export const terminalStyle = {
  theme: {
    background: "#1a1b1d",
    foreground: "white",
    cursor: "#6448ef",
  },
  fontSize: 10,
  fontWeight: 500,
  cursorInactiveStyle: "outline",
  className: "m-2",
};
